define('home/mixins/withClickLinkTracking',[
    'jquery',
    'underscore',
    'core/bus',
], function (
    $,
    _,
    bus
) {
    'use strict';

    // Debounce triggerClick so that an element that has multiple click
    // handlers on it that call trackClickLink with different event
    // objects will end up being debounced by this function and only
    // tracked once.
    var triggerClick = _.debounce(function (evt, params) {
        bus.trigger('uiAction:clickLink', evt, params);
    }, 500, true);

    return function (area) {
        this.trackClickLink = function (evt) {
            // Ignore if the link is taking the user to edit their post.
            // Prevents us from tracking one click as two separate events.
            if (evt.currentTarget.dataset.action === 'edit')
                return;
            var $target = $(evt.currentTarget);
            var params = {
                adjective: $target.attr('data-link-name'),
            };

            // Use the area as given when this mixin was applied, if any.
            // Otherwise use an area defined in the dom, if any.
            if (area)
                params.area = area;
            else
                params.area = $target.closest('[data-jester-area]').attr('data-jester-area');

            triggerClick(evt, params);
        };
    };
});

